<template>
  <header ref="headerMain" class="TheHeader Header">
    <!--  不显示  -->
    <!--    <PreHeader :class="{'_show': isScrollBottom}"/>-->
    <app-container>
      <div class="header">
        <router-link to="/" class="link">
          <div class="header__logo"></div>
        </router-link>
        <div class="header__wrapper">
          <div v-if="!isMobile" class="header__menu">
            <nav class="menu">
              <router-link to="/">
                <li class="menu__item">首页</li>
              </router-link>
              <router-link to="/informed">
                <li class="menu__item">资讯动态</li>
              </router-link>
              <router-link to="/researchDev">
                <li class="menu__item">研发中心</li>
              </router-link>
              <router-link to="/product">
                <li class="menu__item">产品中心</li>
              </router-link>
              <router-link to="/supplyChain">
                <li class="menu__item">供应链中心</li>
              </router-link>
              <router-link to="/oldPlan">
                <li class="menu__item">旧改计划</li>
              </router-link>
              <router-link to="/about">
                <li class="menu__item">关于我们</li>
              </router-link>
            </nav>
          </div>
          <div class="callMeBtn" @click="openDialog">
            <span>联系我们</span>
          </div>
          <transition name="slide-fade"></transition>
          <div v-if="isMobile" class="burger-menu">
            <div class="burger-menu__btn" :class="{ _active: isActiveMenu }" @click="BurgerMenuActive()">
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <nav v-if="isMobile" class="burger-menu__wrapper" :class="{ _visibility: isActiveMenu }">
        <router-link to="/">
          <li class="burger-menu__item" @click="isActiveMenu = false">首页</li>
        </router-link>
        <router-link to="/researchDev">
          <li class="burger-menu__item" @click="isActiveMenu = false">研发中心</li>
        </router-link>
        <router-link to="/product">
          <li class="burger-menu__item" @click="isActiveMenu = false">产品中心</li>
        </router-link>
        <router-link to="/supplyChain">
          <li class="burger-menu__item" @click="isActiveMenu = false">供应链中心</li>
        </router-link>
        <router-link to="/oldPlan">
          <li class="burger-menu__item" @click="isActiveMenu = false">旧改计划</li>
        </router-link>
        <router-link to="/about">
          <li class="burger-menu__item" @click="isActiveMenu = false">关于我们</li>
        </router-link>
      </nav>
    </app-container>
    <contact-us-page />
  </header>
</template>

<script>
import AppContainer from './components/AppContainer.vue';
import { mapState, mapGetters, mapActions } from "vuex";
import contactUsPage from "@/components/contactUsPage.vue";
export default {
  name: 'TheHeader',

  components: {
    contactUsPage,
    AppContainer,
  },
  computed: {
    ...mapState(["isMobile"]),
    ...mapGetters(["getVisibleHeight"])
  },
  data() {
    return {
      isActiveMenu: false,
    };
  },
  mounted() {
    this.handleSize()
    window.addEventListener('resize', this.handleSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleSize);
  },

  methods: {
    ...mapActions(['updateContactDialog']), // 映射 action
    openDialog() {
      this.updateContactDialog(true); // 修改 contactDialog 的值为 true
    },
    handleSize() {

      this.$store.commit("setIsMobile", window.innerWidth <= 768);
      // console.log("🚀 ~ handleSize ~ window.innerWidth:", window.innerWidth);

      // 实时计算去除header栏以外的可视化高度
      this.$store.commit("setVisibleHeight", window.innerHeight - this.$refs.headerMain.clientHeight);
    },
    BurgerMenuActive() {
      this.isActiveMenu = !this.isActiveMenu;
      document.body.style.overflow = this.isActiveMenu ? 'hidden' : 'auto';
    },

  }
}
</script>

<style scoped lang="scss">
.TheHeader {
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  margin-bottom: -58px;
  background-color: #000000;
  z-index: 9;
}

.Header {
  transition: transform .3s linear, box-shadow .3s ease, border .3s ease;
}

.header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 58px;
  z-index: 99;
  background-color: #000;

  &__logo {
    width: 130px;
    height: 24px;
    background: url("./../assets/images/SYLogo.png");
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }

  &__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 700px;

    .callMeBtn {
      width: 80px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      font-size: 12px;
      color: #FFFFFF;
      background: #FF0053;
      border-radius: 13px;
      cursor: pointer;
      user-select: none;
      z-index: 99;

      &:hover {
        background: #ff3375;
      }

      &:active {
        background: #b3003a;
      }
    }

  }

  &__menu {
    width: 520px;
  }
}

@media screen and (max-width: 1200px) {
  .header__wrapper {
    width: 560px;

    .header__menu {
      width: 439px;
    }
  }
}

@media screen and (max-width: 768px) {
  .link {
    z-index: 99;
  }

  a {
    text-decoration: none;
  }

  .router-link-active {
    text-decoration: none;
  }

  .header__logo {
    width: 40px;
    height: 24px;
    background: url("./../assets/images/SYLogoMini.png") no-repeat;
    background-size: cover;
    cursor: pointer;
    z-index: 99;
  }

  .header__wrapper {
    width: 130px;
  }
}

.menu {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__item {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #999999;
    list-style: none;
    transition: all .3s linear;
    cursor: pointer;

    &:hover {
      color: #ff0053;
    }
  }

  & a {
    text-decoration: none;
  }
}



.burger-menu {

  &__btn {
    position: relative;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    width: 25px;
    height: 26px;
    cursor: pointer;
    z-index: 99;

    & span,
    & span::before,
    & span::after {
      position: absolute;
      display: block;
      width: 100%;
      height: 2px;
      background-color: #616161;
      transition: all .4s linear;
    }

    & span::before {
      content: '';
      top: -8px;
    }

    & span::after {
      content: '';
      top: 8px;
    }

    &._active {
      & span {
        transform: rotate(45deg);
      }

      & span::before {
        top: 0;
        transform: rotate(0);
      }

      & span::after {
        top: 0;
        transform: rotate(90deg);
      }
    }

  }

  &__wrapper {
    z-index: 11;
    display: block;
    position: fixed;
    transition: top 0.5s ease-in-out;
    top: -100%;
    left: 0;
    width: 100%;
    height: 100%;
    // margin: 0;
    padding: 30px 0;
    list-style: none;
    text-align: center;
    // background: #35B8BE;
    background-color: #000000;
    box-shadow: 1px 0 6px rgba(0, 0, 0, .2);
    // transition: all .5s linear;


    &._visibility {
      top: 58px;
      border-top: 1px solid #ccc;
    }
  }

  &__item {
    display: block;
    padding: 25px 24px;
    color: #ccc;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 5px;
    text-decoration: none;
    transition: all .4s linear;
  }

  & a {
    text-decoration: none;
  }
}

._show {
  height: 48px;
  // transform: translate3d(0, -100%, 0);
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active до версии 2.1.8 */
  {
  transform: translateX(10px);
  opacity: 0;
}

.router-link-exact-active {
  li {
    color: #fff;
    font-weight: normal;
  }
}
</style>